<template>
  <v-card class="py-2 modal-search-purpose-of-uses">
    <div class="px-2" ref="modalScrollArea">
        <div class="modal-content">
            <div class="overflow-y-auto" style="margin-bottom: 50px;">
                <div class="modal-header">
                    <v-card-title>
                        <div class="modal_header_text">
                        <span>利用用途から探す</span>
                        <h2>
                            ※最大5つまで選択できます。大カテゴリを
                            「すべて」で選択している場合は1つとしてカウントされます。
                        </h2>
                        </div>
                    </v-card-title>
                    <button @click="closeModal" type="button" class="btn-close_popup">
                        <i class="fa-solid fa-xmark" style="color: #2892d7"></i>
                    </button>
                </div>
                <div class="card-text">
                    <div class="modal-header" v-if="selectedSummaryNew.length != 0">
                        <h3>適用中の利用用途 &nbsp;<a href="javascript:void(0)" @click="clearSelection" >クリア</a></h3>
                        <div class="header_text_block">
                            <span v-for="(item, index) in selectedSummaryNew" :key="index">
                                {{ item.type === 'all' ? item.name + 'すべて' : item.name }}
                            </span>
                        </div>
                    </div>
                    <div class="accordion-container">
                        <div v-for="(section, index) in accordionData" :key="index" class="accordion-section">
                            <div class="accordion-header" :class="{ open: openSections[index] }" >
                                <div class="accordian_Text"  @click="toggleAccordion(index)">
                                    <h3>{{ section.name }}</h3>
                                    <span v-html=" openSections[index]
                                        ? '<i class=\'fa-solid fa-angle-down\' ></i>'
                                        : '<i class=\'fa-solid fa-angle-up\'></i>'
                                    " ></span>
                                </div>
                                <button class="min-w-[65px]" @click="selectAll(section)" :class="{ active: !isAllSelected(section) }" :disabled="isDisabled(section.children, section.id)">すべて</button>
                            </div>
                            <div v-if="openSections[index]" class="accordion-content">
                                <div class="accordian_contant_button">
                                    <button @click="selectAll(section)" :class="{ active: !isAllSelected(section) }" :disabled="isDisabled(section.children, section.id)" >すべて</button>
                                </div>
                                <div class="accordianCustomeCheckBox_Detail">
                                    <label v-for="(item, i) in section.children" :key="i" class="custom-checkbox" :class="{ 'disabled-label': isDisabled(item, item.parent) || isSelectedDisabled(item) }">
                                    <input type="checkbox" v-model="selectedItems" :value="item" :disabled="isDisabled(item, item.parent) || isSelectedDisabled(item)"/>
                                    <span class="checkmark"></span>
                                    {{ item.name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal_bottom_contant">
                <a href="javascript:void(0)" @click="clearSelection">クリア</a>
                <button @click="applyConditions">条件を適用する</button>
            </div>
        </div>
    </div>
  </v-card>
</template>

<script setup>
/* eslint-disable */
import { ref, defineEmits, onMounted, computed } from "vue"; 
import "@/client/components/SearchComponent/ModalSearchPurposeOfUses.scss";
import { string } from "yup";

// Emit event for closing modal
const emit = defineEmits(["handleClosePurposeOfUsesModal"]);
const closeModal = () => {
  emit("handleClosePurposeOfUsesModal");
};

const props = defineProps({
    dataUsesPopup: {
        type: string,
        default: () => "",
    },
    allListCategory: {
    type: Array,
    required: true,
  },
});

const accordionData = ref([]);

//  State to track which accordion section is open
const openSections = ref(
  accordionData.value.map(() => true) //  All sections open by default
);

const toggleAccordion = (index) => {
  openSections.value[index] = !openSections.value[index]; // Toggle specific section
};

// Select All Items in Section
const selectedItems = ref([]);

const isAllSelected = (section) => {
  if (!section.children || section.children.length === 0) {
    return selectedItems.value.some(item => item.id === section.id);
  }
  return section.children.every(child =>
    selectedItems.value.includes(child)
  );
};
const wasAllSelectedMap = ref({});
const selectAll = (section) => {
  if (!section.children || section.children.length === 0) {
    // Add parent as a pseudo child if it has no children
    const alreadySelected = selectedItems.value.find(item => item.id === section.id);
    if (alreadySelected) {
      selectedItems.value = selectedItems.value.filter(item => item.id !== section.id);
    } else {
      selectedItems.value.push({ id: section.id, name: section.name });
    }
    return;
  }
  const allSelected = isAllSelected(section);
  wasAllSelectedMap.value[section.id] = !allSelected;
  if (allSelected) {
    // Unselect all
    selectedItems.value = selectedItems.value.filter(
      item => !section.children.includes(item)
    );
  } else {
    // Select all
    section.children.forEach(child => {
      if (!selectedItems.value.includes(child)) {
        selectedItems.value.push(child);
      }
    });
  }
  
};

onMounted(async () => {
  try {
    // const response = await getAllListCategorySpaceApi();
    const response = props.allListCategory;
    accordionData.value = response.data;
    accordionData.value.forEach((_, index) => {
      openSections.value[index] = true;
    });
    const queryCategoryIds = props.dataUsesPopup?.id
      ? props.dataUsesPopup.id.split(",").map(id => Number(id))
      : [];
    accordionData.value.forEach(section => {
      const isParentSelected = queryCategoryIds.includes(section.id);
      const hasChildren = section.children && section.children.length > 0;

    if (!hasChildren && isParentSelected) {
    // Parent with no children and ID is selected
    if (!selectedItems.value.find(i => i.id === section.id)) {
        selectedItems.value.push({ id: section.id, name: section.name });
    }
    }
      section.children.forEach(child => {
        const isChildSelected = queryCategoryIds.includes(child.id);

        if (isParentSelected || isChildSelected) {
          if (!selectedItems.value.find(i => i.id === child.id)) {
            selectedItems.value.push(child);
          }
        }
      });
    });
    accordionData.value.forEach(section => {
        const children = section.children || [];
        const allChildrenSelected = children.length > 0 &&
            children.every(child => selectedItems.value.find(i => i.id === child.id));
        wasAllSelectedMap.value[section.id] = allChildrenSelected;
    });
    selectedSummaryNew.value = selectedSummary.value;

  } catch (err) {
    console.error("Failed to fetch categories", err);
  }
});

const selectedSummary = computed(() => {
  const selectedIds = selectedItems.value.map(item => item.id);
  const result = [];

    accordionData.value.forEach(section => {
        const hasChildren = section.children && section.children.length > 0;

        if (!hasChildren) {
        // Parent with no children: show if it's selected
        if (selectedIds.includes(section.id)) {
            result.push({ type: 'all', name: `${section.name}` });
        }
        return;
        }
        
        const selectedChildren = section.children.filter(child =>
        selectedIds.includes(child.id)
        );
        if (selectedChildren.length === section.children.length) {
        // All children selected → show parent with "すべて"
        result.push({ type: 'all', name: section.name });
        } else {
        // Some children selected → show each name
        selectedChildren.forEach(child => {
            result.push({ type: 'child', name: child.name });
        });
        }
    });

  return result;
});

const selectedCount = computed(() => selectedSummary.value.length);

const getSelectedCount = () => {
    let selected = selectedItems.value;
    let parentSelected = [];

    let selectedParentId = selected.reduce((acc, item) =>{
        const key = item.parent;
        acc[key] = (acc[key] || 0) + 1;
        return acc;
    }, {});

    Object.keys(selectedParentId).forEach(key => {
        var children = accordionData.value.find(section =>section.id == key)?.children || [];
        var allChildSelected = children.every(child => selected.some(i =>i.id === child.id));
        if (allChildSelected) {
            parentSelected.push(key);
        }
    });
    
    let childSelected = selected.filter(item => !parentSelected.includes(String(item.parent)))

    return {
        totalParentSelected: parentSelected.length,
        totalChildSelected: childSelected.length
    }
};

const isDisabled = (itemOrArray, sectionId) => {
  const isItem = !Array.isArray(itemOrArray);

  const countByParent = selectedItems.value.filter((item => item.parent != sectionId)).reduce((acc, item) =>{
      const key = item.parent;
      acc[key] = (acc[key] || 0) + 1;
      return acc;
  }, {});

  if (isItem) {
    const children = accordionData.value.find(section =>section.id == sectionId)?.children || [];
    if (Object.keys(countByParent).length == 4 && children.length <= 2) {
        return false;
    }
    if (Object.keys(countByParent).length == 3 && children.length <= 3) {
        return false;
    }
    if (Object.keys(countByParent).length == 2 && children.length <= 4) {
        return false;
    }
    if (Object.keys(countByParent).length == 1 && children.length <= 5) {
        return false;
    }
    const isSelected = selectedItems.value.includes(itemOrArray);
    return !isSelected && selectedCount.value >= 5;
  } else {
    // Handle empty children array (e.g., no children in section)
    if (itemOrArray.length === 0) {
        if(sectionId && selectedItems.value.filter(item => sectionId == item.id).length) {
            return false;
        }
      // Prevent selecting this if we already have 5 selected
      return selectedCount.value >= 5;
    }

    // Simulate "すべて" – if ALL items in array are unselected and count will exceed 5
    const unselected = itemOrArray.filter(
      child => !selectedItems.value.includes(child)
    );

    let totalCount = getSelectedCount();
    let count = totalCount.totalChildSelected + totalCount.totalParentSelected;
    const parentCount = selectedItems.value.reduce((acc, item) =>{
        const key = item.parent;
        acc[key] = (acc[key] || 0) + 1;
        return acc;
    }, {});
    if (!Object.keys(parentCount).includes(String(sectionId)) && count >= 5) {
        return true;
    }

    const allChildrenSelected = itemOrArray.every(child =>selectedItems.value.some(i =>i.id === child.id));

    const countByParentOne = selectedItems.value.filter((item => item.parent == sectionId)).reduce((acc, item) =>{
        const key = item.parent;
        acc[key] = (acc[key] || 0) + 1;
        return acc;
    }, {});
    if(Object.keys(countByParentOne).length == 1 && selectedItems.value.filter((item => item.parent == sectionId)).length <= 5) {
        let selectedParent = accordionData.value.find(section => section.id == Object.keys(countByParentOne)[0]);
        let allChildParentSelected = selectedParent.children.every(child =>selectedItems.value.some(i => i.id === child.id));
        if(!allChildParentSelected && Object.keys(countByParentOne)[0] == sectionId) {
            return false;
        }
        if(!allChildParentSelected) {
            return true;
        }
    }
    const countByParentTwo = selectedItems.value.reduce((acc, item) =>{
        const key = item.parent;
        acc[key] = (acc[key] || 0) + 1;
        return acc;
    }, {});
    if(Object.keys(countByParentTwo).length == 1 && selectedItems.value.length ==  5) {
        let selectedParent = accordionData.value.find(section => section.id == Object.keys(countByParentTwo)[0]);
        let allChildParentSelected = selectedParent.children.every(child =>selectedItems.value.some(i => i.id === child.id));
        if(!allChildParentSelected && Object.keys(countByParentTwo)[0] == sectionId) {
            return false;
        }
        if(!allChildParentSelected) {
            return true;
        }
    }
    if(!allChildrenSelected) {
        if (Object.keys(countByParent).length == 4 && itemOrArray.length <= 2) {
            return false;
        }
        if (Object.keys(countByParent).length == 3 && itemOrArray.length <= 3) {
            return false;
        }
        if (Object.keys(countByParent).length == 2 && itemOrArray.length <= 4) {
            return false;
        }
        if (Object.keys(countByParent).length == 1 && itemOrArray.length <= 5) {
            return false;
        }
    }

    if (unselected.length === 0) return false; // all selected already
    return selectedCount.value + 1 > 5;
  }
};


const isSelectedDisabled = (item) => {
    const parent = accordionData.value.find(section =>section.children?.some(child =>child.id === item.id));

    const isChild = !!parent;
    const isSelectedItem = selectedItems.value.some(i =>i.id === item.id);

    // Case 1: Parent with more than 6 children
    const allChildrenSelected = parent.children.every(child =>selectedItems.value.some(i =>i.id === child.id));
    if (isChild && parent.children.length > 6) {
        return allChildrenSelected ? isSelectedItem: false;
    }
    let totalSelectedOptions = selectedItems.value.filter((item =>!parent?.children?.includes(item)));
    
    const countByParent = selectedItems.value.reduce((acc, item) =>{
        const key = item.parent;
        acc[key] = (acc[key] || 0) + 1;
        return acc;
    }, {});

    let totalCount = getSelectedCount();
    let count = totalCount.totalChildSelected + totalCount.totalParentSelected;
    
    if (parent) {
        const parentSelected = parent.children.every((child) =>
            selectedItems.value.some((selected) => selected.id === child.id)
        );
        if (parentSelected) {
            if(totalCount.totalChildSelected == 4 && parent.children.length > 2){
                return true;
            }
            if(totalCount.totalChildSelected == 3 && parent.children.length > 3){
                return true;
            }
            if(totalCount.totalChildSelected == 2 && parent.children.length > 4){
                return true;
            }
            if(totalCount.totalChildSelected == 1 && parent.children.length > 5){
                return true;
            }
            if(totalCount.totalChildSelected == 3 && totalCount.totalParentSelected == 2 && parent.children.length > 2){
                return true;
            }
        }else{
            const isItemSelected = selectedItems.value.some((i) => i.id === item.id);
            if(!parentSelected && count < 5){
                return false; 
            }else{
                if(isItemSelected){
                    return false; 
                }else{
                    return true;
                }
            }
        }
    }
    
    if (!Object.keys(countByParent).includes(String(item.parent)) && count >= 5) {
        return true;
    }

    if (Object.keys(countByParent).includes(String(parent.id))) {
        if(allChildrenSelected) {
            if (Object.keys(countByParent).length == 5 && parent.children.length <= 2) {
                return false;
            }
            if (Object.keys(countByParent).length == 5 && parent.children.length > 2) {
                return true;
            }
            if (Object.keys(countByParent).length == 4 && parent.children.length > 3) {
                return true;
            }
            if (Object.keys(countByParent).length == 3 && parent.children.length > 4) {
                return true;
            }
            if (Object.keys(countByParent).length == 2 && parent.children.length > 5) {
                return true;
            }
            if (Object.keys(countByParent).length == 1 && parent.children.length > 6) {
                return true;
            }
        } else {
            if (count > 4 && !selectedItems.value.filter((i => i.id == item.id)).length && Object.keys(countByParent).length == 3 && parent.children.length >= 4) {
                return true;
            }
            if (count > 4 && !selectedItems.value.filter((i => i.id == item.id)).length && Object.keys(countByParent).length == 2 && parent.children.length >= 4) {
                return true;
            }
        }
    } else {
        if (Object.keys(countByParent).length > 4 && totalSelectedOptions.length > 4) {
            return true;
        }
    }

    if(Object.keys(countByParent).length == 1 && totalSelectedOptions.length == 5) {
        let selectedParent = accordionData.value.find(section => section.id == Object.keys(countByParent)[0]);
        let allChildParentSelected = selectedParent.children.every(child =>selectedItems.value.some(i => i.id === child.id));
        if(!allChildParentSelected) {
            return true;
        }
    }

    if (isChild && parent.children.length <= 6) {
        if (selectedCount.value > 5) {
            return false;
        }
    }

    return false; // default: not locked
};

const clearSelection = () => {
  selectedItems.value = [];
  const selectedParentCategories = [];
  const selectedChildCategories = [];
  emit('applyUsageConditions', { parents: selectedParentCategories, children: selectedChildCategories });
  closeModal();
};
const modalScrollArea = ref(null);
const selectedSummaryNew = ref([]);
const applyConditions = () => {
  const selectedIds = selectedItems.value.map(item => item.id);

  const selectedParentCategories = []; // { id, name }
  const selectedChildCategories = [];  // { id, name }

  accordionData.value.forEach(section => {
    
    const hasChildren = section.children && section.children.length > 0;

    if (!hasChildren) {
      // Handle parent with no children
      if (selectedIds.includes(section.id)) {
        selectedParentCategories.push({
          id: section.id,
          name: section.name,
        });
      }
      return;
    }
    
    const allChildrenSelected = section.children.every(child =>
      selectedIds.includes(child.id)
    );

    if (allChildrenSelected) {
      selectedParentCategories.push({
        id: section.id,
        name: section.name,
      });
    } else {
      section.children.forEach(child => {
        if (selectedIds.includes(child.id)) {
          selectedChildCategories.push({
            id: child.id,
            name: child.name,
          });
        }
      });
    }
  });
  // Emit or use as needed:
  emit('applyUsageConditions', { parents: selectedParentCategories, children: selectedChildCategories });
  selectedSummaryNew.value = selectedSummary.value;
//   modalScrollArea.value?.scrollTo({ top: 0, behavior: 'smooth' });
  closeModal();
};



</script>
